import { effect, inject } from '@angular/core';
import { getState, signalStoreFeature, withHooks } from '@ngrx/signals';
import { History } from '../../models/history';
import { HistoryStore } from '../history/history.state';

export function withLogging(entityType: string) {
  return signalStoreFeature(
    withHooks({
      onInit(store) {
        const historyStore = inject(HistoryStore);
        effect(
          () => {
            const state: any = getState(store);
            const { action, lastPersistedId, lastPersistedLabel } = state; // Assuming these are part of the state

            if (action) {
              const historyEntry: History = {
                _id: '',
                action,
                entityId: lastPersistedId,
                entityType,
                description: lastPersistedLabel,
              };

              historyStore.addItem(historyEntry); // persist the action
            }
          },
          { allowSignalWrites: true }
        );
      },
    })
  );
}
